module.exports = __webpack_public_path__ + "img/added-service-unit-05.1f10c7a4.png";